import React, { useEffect, useState } from "react";
import { Box, Tabs, Tab, Paper, Fade } from "@mui/material";
import { useLocation } from "react-router-dom";
import ResponseLayout from "./ResponseLayout";
import CalibrationLayout from "./CalibrationLayout";
import PredictionLayout from "./PredictionLayout";

export default function NavigationTabs() {
    const [activeTab, setActiveTab] = useState(0);
    const location = useLocation();

    // Switch to the Prediction tab automatically when CalibrationLayout pushes
    // a fresh calibration via navigate("/microslide", { state: { ... } }).
    useEffect(() => {
        const cal = location?.state?.calibrationResponse;
        const open = location?.state?.openPredictionTab;
        if (open && cal && Object.keys(cal).length > 0) {
            setActiveTab(2);
        }
    }, [location]);

    const handleChange = (event, newValue) => setActiveTab(newValue);

    const tabs = [
        { label: "Response", component: <ResponseLayout /> },
        { label: "Calibration", component: <CalibrationLayout /> },
        { label: "Prediction", component: <PredictionLayout /> }
    ];

    return (
        <Paper
            elevation={1}
            sx={{
                width: "100%",
                margin: "10px",
                mt: 2,
                borderRadius: 2,
                overflow: "hidden"
            }}
        >
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    textColor="inherit"
                    indicatorColor="none"
                    sx={{
                        "& .MuiTab-root": {
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "1rem",
                            minWidth: 200,
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            color: "white",
                            backgroundColor: "#774def",
                            transition: "none"
                        },
                        "& .MuiTab-root:hover": {
                            color: "white",
                            fontWeight: 600,
                            fontSize: "1.1rem",
                            backgroundColor: "#774def"
                        },
                        "& .Mui-selected": {
                            color: "white",
                            backgroundColor: "#774def",
                            boxShadow: "none"
                        },
                        "& .MuiTabs-indicator": { display: "none" }
                    }}
                >
                    {tabs.map((t, i) => <Tab key={i} label={t.label} />)}
                </Tabs>
            </Box>

            <Box sx={{ position: "relative", minHeight: 500, overflow: "hidden" }}>
                {tabs.map((t, i) => (
                    // Inactive tabs stay mounted (display: none) so per-tab
                    // useState - parameter overrides, spline edits, history -
                    // survives a tab switch. Without this each switch unmounts
                    // the layout and the next visit starts from defaults.
                    <Box
                        key={i}
                        sx={{
                            display: activeTab === i ? "block" : "none",
                            width: "100%"
                        }}
                    >
                        <Fade in={activeTab === i} timeout={300}>
                            <Box sx={{ width: "100%" }}>
                                {t.component}
                            </Box>
                        </Fade>
                    </Box>
                ))}
            </Box>
        </Paper>
    );
}
